import shallow from 'zustand/shallow';
import useStore from '../stores';

function useShallowStore(selector) {
  return useStore(selector, shallow);
}

export default useShallowStore;
